import { RedirectRouteInformation } from 'common/routing/page-definition'

export const getRedirectRouteInfo = (to: string): RedirectRouteInformation => {
    return {
        kind: 'redirect',
        redirectTo: {
            targetUrl: to,
        },
    }
}
